
function fixedNumber(number:number, allowNegative?:boolean):number {

    let fixedDecimal;

    if(number <= 0 && !allowNegative){
        fixedDecimal = 0
    } else if (number >= 100) {
        fixedDecimal = 100
    } else{
        fixedDecimal = Number(number).toFixed(1);
    }

    return fixedDecimal;
}

export default fixedNumber;